import { AbstractControl } from '@angular/forms';

export function ValidateName(control: AbstractControl): {[key: string]: boolean} {
    if (!(/[a-zA-Z]/.test(control.value)))
        return {'invalidName': true};

    return null;
}